export default __webpack_public_path__ + "static/media/the-high-priestess-pressed@2x.054c7ebf.png";